import './App.css';
import Paperbase, { PageType, TrialProducts } from './material-ui/Paperbase';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import React from 'react';
import { NavigatorData, ProductId, Products } from './material-ui/NavigatorData';
import { AuthContext } from './authentication/AuthContext';
import { useEffect } from 'react';
import useGTM from '@elgorditosalsero/react-gtm-hook';
import { AuthenticationDataSaas, SaaSAuthContext } from './authentication/SaaSAuthContext';
import Cookies from 'universal-cookie';

function App() {

  const authContext = React.useContext(AuthContext);
  const saasContext = React.useContext(SaaSAuthContext);
  const redirectCookie = new Cookies();


  const { init, UseGTMHookProvider } = useGTM();

  useEffect(() => init({ id: 'GTM-5N26MG' }), []);

  function handleAuthentication() {
    if (/access_token|id_token|error|token/.test(window.location.hash)) {
      authContext.handleAuthentication();
    }
  };

  function parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  function handleDownload(product: TrialProducts) {
    if (/access_token|id_token|error|token/.test(window.location.hash)) {
      const hashString = window.location.hash.substring(1); 
      const decodedHashString = decodeURIComponent(hashString); 
      const jsonObject = JSON.parse('{"' + decodeURI(decodedHashString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      const extractPayload = parseJwt(jsonObject.id_token);
      const tokenData: AuthenticationDataSaas = {
        refresh_token: jsonObject.refresh_token,
        expires_at: extractPayload.exp,
        id_token: jsonObject.id_token
      };
      saasContext.download(product, tokenData);
    }
  };

  React.useEffect(() => {
    authContext.refreshSession();
  }, []);

  const updateReturnPath = (path: string) => {
    // Dont want to set return path to / or /callback
    if (!(path === '/' || path === '/callback')){
      //Set new redirect URL value
      redirectCookie.set('redirectCookie', path, { path: '/' });
    }
  }

  //Capture current URL
  updateReturnPath(window.location.pathname)

  return (
    <UseGTMHookProvider>
      <Router>
        <AuthContext.Provider value={authContext}>
          <SaaSAuthContext.Provider value={saasContext}>
            <div className="App">
              <Switch>
                <Route path={NavigatorData.baseUrl}>
                  <Paperbase pageType={PageType.Home} />
                </Route>
                <Route path={NavigatorData.profileBaseUrl}>
                  <Paperbase pageType={PageType.Profile} />
                </Route>
                <Route path={NavigatorData.evaluationManagerBaseUrl}>
                  <Paperbase pageType={PageType.EvaluationManager} />
                </Route>
                <Route path={NavigatorData.licenseManagerBaseUrl}>
                  <Paperbase pageType={PageType.LicenseManager} />
                </Route>
                <Route path={NavigatorData.subscriptionManagerBaseUrl}
                   render={() => {
                     handleAuthentication();
                     return <Redirect to={NavigatorData.baseUrl} />;
                  }}/>
                <Route path={NavigatorData.saasProductsBaseUrl}   
                    render={() => {
                     handleAuthentication();
                     return <Redirect to={NavigatorData.baseUrl}  />;
                  }}/>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.xmlCompare)}>
                  <Paperbase pageType={PageType.downloadXmlCompare} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.xmlDataCompare)}>
                  <Paperbase pageType={PageType.downloadXMLDataCompare} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.ditaCompare)}>
                  <Paperbase pageType={PageType.downloadDitaCompare} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.docbookCompare)}>
                  <Paperbase pageType={PageType.downloadDocBookCompare} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.xmlMerge)}>
                  <Paperbase pageType={PageType.downloadXmlMerge} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.ditaMerge)}>
                  <Paperbase pageType={PageType.downloadxmlDitaMerge} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.deltaJson)}>
                  <Paperbase pageType={PageType.downloadDeltaJson} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.conversionQA)}>
                  <Paperbase pageType={PageType.downloadConversionQA} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.htmlCompare)}>
                  <Paperbase pageType={PageType.downloadHtmlCompare} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.linuxLicenseServer)}>
                  <Paperbase pageType={PageType.downloadLinuxLicenseServer} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.windowsLicenseServer)}>
                  <Paperbase pageType={PageType.downloadWindowsLicenseServer} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.macIntelLicenseServer)}>
                  <Paperbase pageType={PageType.downloadMacIntelLicenseServer} />
                </Route>
                <Route path={NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.macARMLicenseServer)}>
                  <Paperbase pageType={PageType.downloadMacARMLicenseServer} />
                </Route>
               <Route path={NavigatorData.downloadProductUrl}>
                  <Paperbase pageType={PageType.downloadProducts} />
                </Route>
                {/* <Route
                  path={NavigatorData.callbackBaseSaasUrl[ProductId.ccS1000D]}
                  render={() => {
                    handleDownload(ProductId.ccS1000D);
                    return <Redirect to={NavigatorData.subscriptionManagerBaseUrl} />;
                  }}
                />
                <Route
                  path={NavigatorData.callbackBaseSaasUrl[ProductId.ccJATS]}
                  render={() => {
                    handleDownload(ProductId.ccJATS);
                    return <Redirect to={NavigatorData.subscriptionManagerBaseUrl} />;
                  }}
                />
                <Route
                  path={NavigatorData.callbackBaseSaasUrl[ProductId.ccBITS]}
                  render={() => {
                    handleDownload(ProductId.ccBITS);
                    return <Redirect to={NavigatorData.subscriptionManagerBaseUrl} />;
                  }} />
                <Route
                  path={NavigatorData.callbackBaseSaasUrl[ProductId.ccNISOSTS]}
                  render={() => {
                    handleDownload(ProductId.ccNISOSTS);
                      return <Redirect to={NavigatorData.subscriptionManagerBaseUrl} />;
                  }}
                />
                <Route
                  path={NavigatorData.callbackBaseSaasUrl[ProductId.ccXSLFO]}
                  render={() => {
                    handleDownload(ProductId.ccXSLFO);
                    return <Redirect to={NavigatorData.subscriptionManagerBaseUrl} />;
                  }}
                  /> */}
                <Route
                  path={NavigatorData.callbackBaseUrl}
                  render={() => {
                    handleAuthentication();
                    return <Redirect to="/" />;
                  }}
                />
                <Route
                  path={"/"}
                  render={() => {
                    // If undefined go to /home
                    if (redirectCookie.get('redirectCookie') === undefined){
                    redirectCookie.set('redirectCookie', NavigatorData.baseUrl, { path: '/' })
                    }
                    return <Redirect to={redirectCookie.get('redirectCookie')} />;
                  }}
                />
              </Switch>
            </div>
          </SaaSAuthContext.Provider>
        </AuthContext.Provider>
      </Router>
    </UseGTMHookProvider>
  );
}

export default App;
